import PrivateNetworkClient from "helpers/privateNetwork";

const DownloadCSV = async (uri,searchKey, page, size) => {
    const { data } = await PrivateNetworkClient.get(`/${uri}?searchKey=${searchKey}&page=${page}&size=${size}`);
    return data;
}

const PostDownload = async (uri, formData) => {
    const body = typeof formData === "string" ? JSON.parse(formData) : formData;
    const { data } = await PrivateNetworkClient.post(`/${uri}`, body, { responseType: "blob" });
    return data;
}



export {
    DownloadCSV,
    PostDownload
}